import { Command } from 'commander';
import {
  AddColumnsCommand,
  GenerateColumnsCommand,
  RemoveColumnsCommand,
} from '../tables/tableCommand';

export function ColumnsCommand(): Command {
  const cmd = new Command('table-columns');
  cmd.alias('tb').description("Manage columns for a task's table.");

  cmd.addCommand(GenerateColumnsCommand('task'));
  cmd.addCommand(AddColumnsCommand('task'));
  cmd.addCommand(RemoveColumnsCommand('task'));
  return cmd;
}
